<template>
    <div class="fse_wrap">
        <div class="editorwindow">
            <div class="titlebar">
                <div class="subject">
                    {{titleSubject}}
                </div>
                <div class="buttons">
                    <icon-button icon="times" @click="$store.commit('setEditorMode', 0)"></icon-button>
                </div>
            </div>
            <div class="editorwrap">
                <message-editor :subject.sync="subject" :message="message"></message-editor>
            </div>
        </div>
    </div>
</template>

<script>
import MessageEditor from '@/components/messageEditor';
import IconButton from '@/components/iconButton';

export default {
  name: 'fullScreenEditor',
  components: { IconButton, MessageEditor },
  data() {
    return {
      subject: ''
    };
  },
  props: {
    message: Object
  },
  created() {
    if ((this.message) && (this.message.subject)) {
      this.subject = this.message.subject;
    }
  },
  methods: {
  },
  computed: {
    titleSubject() {
      return this.subject ? this.subject : this.$t('messageEditor.noSubjectTitle');
    }
  }
};
</script>

<style scoped lang="scss">
    @import '../assets/bootstrap-style.scss';

    .fse_wrap {
        position: fixed;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        background-color: rgba($gray-900, 0.4);
        z-index: 50;

        .editorwindow {
            position: absolute;
            z-index: 60;
            background-color: $white;
            opacity: 1;
            height: 90vh;
            width: 90vw;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            border: 1px solid $black;
            border-radius: 5px;
            display: flex;
            flex-direction: column;

            .titlebar {
                flex: 0 0 20px;
                background-color: $message-editor-titlebar;
                display: flex;
                .subject {
                    flex-grow: 1;
                    font-weight: bold;
                    padding-left: 10px;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }
                .buttons {
                    flex: 0;
                    white-space: nowrap;
                }
            }
            .editorwrap {
                flex: 1;
                width: 100%;
                height: 100%;
            }
        }
    }

</style>
